module.exports = __webpack_public_path__ + "img/PD1505111306439622656.8805a819.png";